import React from "react";
import {
    Container,
    FormControl,
    InputAdornment,
    InputLabel,
    MenuItem,
    Paper,
    Select,
    Stack,
    TextField,
} from "@mui/material";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import SortRoundedIcon from "@mui/icons-material/SortRounded";

const IncomeToolbar = ({ query, onQueryChange, sortBy, onSortByChange }) => (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
        <Paper variant="outlined" sx={{ p: 2, borderRadius: 3, borderColor: "divider", backgroundColor: "background.paper" }}>
            <Stack
                direction={{ xs: "column", md: "row" }}
                spacing={2}
                alignItems={{ xs: "stretch", md: "center" }}
                justifyContent="space-between"
            >
                <TextField
                    size="small"
                    fullWidth
                    placeholder="Suche nach Anzeigename, Datei oder Kunde"
                    value={query}
                    onChange={(e) => onQueryChange(e.target.value)}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchRoundedIcon />
                            </InputAdornment>
                        ),
                    }}
                />
                <Stack direction="row" spacing={1.5} alignItems="center">
                    <SortRoundedIcon sx={{ opacity: 0.6 }} />
                    <FormControl size="small" sx={{ minWidth: 180 }}>
                        <InputLabel id="sort-by-label">Sortieren nach</InputLabel>
                        <Select
                            labelId="sort-by-label"
                            id="sort-by-select"
                            label="Sortieren nach"
                            value={sortBy}
                            onChange={(e) => onSortByChange(e.target.value)}
                        >
                            <MenuItem value="date-desc">Neueste zuerst</MenuItem>
                            <MenuItem value="date-asc">Älteste zuerst</MenuItem>
                            <MenuItem value="name-asc">Name A–Z</MenuItem>
                            <MenuItem value="name-desc">Name Z–A</MenuItem>
                        </Select>
                    </FormControl>
                </Stack>
            </Stack>
        </Paper>
    </Container>
);

export default IncomeToolbar;
